/**
 * Mount point for the TagadaPay External Page Tracker.
 *
 * Renders nothing. Initializes the tracker once when credentials are present,
 * destroys on unmount, and lets the rest of the app fire events via the
 * helpers in `lib/tagadaTracker.js`.
 *
 * Tracker page_view events are emitted from `lib/analytics.trackPageView`,
 * which fires on every route change via the SEO component.
 */
import { useEffect } from 'react';
import { initTagada, destroyTagada } from '../lib/tagadaTracker';

export default function TagadaTrackerMount() {
  useEffect(() => {
    initTagada();
    return () => {
      destroyTagada();
    };
  }, []);
  return null;
}
